module.exports = __webpack_public_path__ + "img/isracard.8be958ef.jpg";